import React from 'react'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import { BiChevronDown } from 'react-icons/bi'
import { useDispatch } from 'react-redux'
import { logout } from '../../../redux'
import style from "../header.module.css"
import {
    Link,
    useLocation,
    useNavigate
} from 'react-router-dom'
import {
    Avatar,
    Box,
    Button,
    Flex,
    Heading,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    useBreakpointValue,
    useColorMode
} from '@chakra-ui/react'
import routeConfig from '../../../configs/route.config'

const UserButton = () => {
    const { t } = useTranslation()
    const currentLanguage = i18next.language;

    let stringUserData: string = localStorage.getItem('user_data') || ""
    const userData = stringUserData ? JSON.parse(stringUserData) : {}
    const isDesktop = useBreakpointValue({ base: false, md: true })
    const location = useLocation()
    const isBlacklistPage = location.pathname === routeConfig.teams
    const dispatch = useDispatch<any>()
    const navigate = useNavigate()

    const changeLanguage = (lng: string) => {
        i18next.changeLanguage(lng);
        localStorage.setItem('i18nextLng', lng)
    }

    function handleLogout() {
        dispatch(logout())
        navigate(routeConfig.login, { replace: true })
        window.location.reload()
    }

    return (
        <Menu>
            {isDesktop ?
                <MenuButton as={Button} rightIcon={<BiChevronDown />} className={style.profile_dropdown}>
                    <Flex alignItems="center" gap="10px">
                        <Avatar
                            name={userData.display_name}
                            src={userData.photo_url}
                            className={style.profile_picture}
                            fontSize="10px"
                            size='sm'
                        />
                        <Heading size='chakra_body_large'>{userData.display_name}</Heading>
                    </Flex>
                </MenuButton>
                :
                <MenuButton>
                    <Avatar
                        name={userData.display_name}
                        src={userData.photo_url}
                        size='sm'
                    />
                </MenuButton>
            }
            <MenuList className={style.profile_dropdown_content} shadow='md' padding='16px'>
                {!isBlacklistPage &&
                    <Link to={routeConfig.teams}>
                        <MenuItem
                            className={style.profile_dropdown_content_item}
                            backgroundColor='surfacePlus1'
                            _hover={{
                                backgroundColor: 'surfacePlus3',
                                borderRadius: '4px'
                            }}
                        >
                            <span className={`material-symbols-outlined`}>change_circle</span>
                            <Heading size='chakra_body_large'>{t("header_ganti_tim")}</Heading>
                        </MenuItem>
                    </Link>
                }
                
                <Menu placement="right-start"> 
                    <MenuButton
                        className={`${style.profile_dropdown_content_item}`}
                        _hover={{
                            backgroundColor: 'surfacePlus3',
                            borderRadius: '4px'
                        }}
                        w="full"
                    >
                        <Flex gap="16px" alignItems='center'>
                            <span className={`material-symbols-outlined`}>language</span>
                            <Heading size='chakra_body_large'>{t("header_ganti_bahasa")}</Heading>
                            <Box as="span" ml="auto" className={`material-symbols-outlined`}>navigate_next</Box>
                        </Flex>
                    </MenuButton>
                    <MenuList
                        shadow="2xl"
                        className={`${style.profile_dropdown_content}`}
                        padding='16px'
                        zIndex={999}
                    >
                        <MenuItem
                            className={`${style.profile_dropdown_content_item}`}
                            onClick={() => changeLanguage('id')}
                            backgroundColor='surfacePlus1'
                            _hover={{ backgroundColor: 'surfacePlus3', borderRadius: '4px' }}
                        >
                            <Flex justifyContent="space-between" alignItems="center" w="full">
                                <Heading size='chakra_body_large'>{t("header_ganti_bahasa_indonesia")}</Heading>
                                {currentLanguage === 'id' && (
                                    <span className="material-symbols-outlined" style={{ color: 'green' }}>check</span>
                                )}
                            </Flex>
                        </MenuItem>

                        <MenuItem
                            className={`${style.profile_dropdown_content_item}`}
                            onClick={() => changeLanguage('en')}
                            backgroundColor='surfacePlus1'
                            _hover={{ backgroundColor: 'surfacePlus3', borderRadius: '4px' }}
                        >
                            <Flex justifyContent="space-between" alignItems="center" w="full">
                                <Heading size='chakra_body_large'>{t("header_ganti_bahasa_inggris")}</Heading>
                                {(currentLanguage === 'en' || currentLanguage.startsWith('en-')) && (
                                    <span className="material-symbols-outlined" style={{ color: 'green' }}>check</span>
                                )}
                            </Flex>
                        </MenuItem>
                    </MenuList>
                </Menu>

                <MenuItem
                    className={`${style.profile_dropdown_content_item} ${style.logout}`}
                    onClick={handleLogout} backgroundColor='surfacePlus3'
                    _hover={{
                        backgroundColor: 'surfacePlus3',
                        borderRadius: '4px'
                    }}
                >
                    <span className={`material-symbols-outlined`}>logout</span>
                    <Heading size='chakra_body_large' color='error'>{t("header_keluar")}</Heading>
                </MenuItem>
            </MenuList>
        </Menu>
    )
}

export default UserButton